<div class="card bg-base-100 border border-base-300 shadow-sm w-full max-w-full">
  <div class="card-body p-3 gap-2">
    <h3 class="font-semibold text-sm break-words">{{ recipe.title }}</h3>
    <p class="text-xs text-base-content/60">
      {{ recipe.servings }} {{ recipe.servings === 1 ? 'Portion' : 'Portionen' }}
      @if (recipe.prep_time_minutes != null) {
        · Vorbereitung {{ recipe.prep_time_minutes }} Min.
      }
      @if (recipe.cook_time_minutes != null) {
        · Kochzeit {{ recipe.cook_time_minutes }} Min.
      }
    </p>
    <ol class="space-y-2 mt-1">
      @for (step of recipe.steps; track step.order) {
        <li class="text-sm">
          <div class="flex items-center gap-2 mb-0.5 flex-wrap">
            <span class="badge badge-sm" [ngClass]="stepBadgeClass(step)">{{ stepTypeLabel(step) }}</span>
            @if (stepSubtitle(step); as subtitle) {
              <span class="text-[11px] text-base-content/50">{{ subtitle }}</span>
            }
          </div>
          <p class="whitespace-pre-wrap break-words">
            @for (segment of stepSegments(step); track $index) {
              @switch (segment.kind) {
                @case ('quantity') {
                  <span class="font-semibold text-primary">{{ segment.text }}</span>
                }
                @case ('ingredient') {
                  <strong>{{ segment.text }}</strong>
                }
                @default {
                  <span>{{ segment.text }}</span>
                }
              }
            }
          </p>
        </li>
      }
    </ol>
  </div>
</div>
